import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import * as fromApp from './../store/app.reducers';
import * as fromError from './store/error.reducers';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    standalone: false
})
export class ErrorComponent implements OnInit {
  
  errorState: Observable<fromError.State>;
  
  constructor(
    private store: Store<fromApp.AppState>
  ) { }
  
  ngOnInit() {
    this.errorState = this.store.select('error');
  }
  
}